import { auditMentionsAuditMentionsDateSchedulesList } from '@mi-front/api-v2';
import { DateStr, DateTimeStr, GetPntScheduleDto, Paginated } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import moment from 'moment-timezone';

/**
 * Resolves the calendar date of a mention detection in the station timezone.
 */
function getMentionScheduleDate(datetime: DateTimeStr, timezone: string): DateStr {
  return moment(datetime).tz(timezone).format('YYYY-MM-DD') as DateStr;
}

/**
 * Loads the programmed mention script (`original`) from the date schedule
 * matching the live mention id (`name` ↔ `customId`) for that station day.
 */
export function useMentionDateScheduleOriginal(
  stationId: string,
  timezone: string,
  mentionName: string | undefined,
  mentionDatetime: DateTimeStr | undefined,
  enabled: boolean,
) {
  const date =
    mentionDatetime != null ? getMentionScheduleDate(mentionDatetime, timezone) : undefined;

  return useQuery({
    queryKey: ['mention-date-schedule-original', stationId, date, mentionName],
    queryFn: async (): Promise<string | null> => {
      if (!mentionName || !date) {
        return null;
      }

      const page = (await auditMentionsAuditMentionsDateSchedulesList({
        station: stationId,
        date,
      })) as Paginated<GetPntScheduleDto>;

      const schedule = page.results.find((item) => item.customId === mentionName);
      const original = schedule?.original?.trim();

      return original || null;
    },
    enabled: enabled && !!mentionName && !!date && !!stationId,
    staleTime: 5 * 60 * 1000,
  });
}
